import { PERMISSIONS } from '@conversed/shared/src/central/constants/permissions';
import { z } from 'zod';
import { createRESTContract } from '../../index';
import { DataSourceDetailsSchema } from '../data-sources/data-sources.schema';
import { SyncBodySchema } from '../data-sources/sync.schema';
import {
  ZendeskSettingsResponseSchema,
  ZendeskSettingsSchema,
} from './zendesk.schema';

export const zendeskContract = createRESTContract({
  syncKnowledgeArticles: {
    method: 'POST',
    path: '/zendesk/knowledge-articles/sync',
    permissions: [],
    body: SyncBodySchema,
    response: DataSourceDetailsSchema,
  },
  getSettings: {
    method: 'GET',
    path: '/zendesk/settings',
    permissions: [PERMISSIONS.COMPANY.COMPANY_GENERAL_SETTINGS_READ],
    response: ZendeskSettingsResponseSchema,
  },
  updateSettings: {
    method: 'PATCH',
    path: '/zendesk/settings',
    permissions: [PERMISSIONS.COMPANY.COMPANY_GENERAL_SETTINGS_EDIT],
    body: ZendeskSettingsSchema,
    response: z.void(),
  },
});
